module.exports = __webpack_public_path__ + "img/menu-arrow-icon.8cd47e01.svg";